import React, { useState, useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import Swal from "sweetalert2";

const images = [
  "/assets/images/bridal/B 19.jpg",
  "/assets/images/bridal/B 39.jpg",
  "/assets/images/bridal/B 28.jpg",
  "/assets/images/couple/C 35.jpg",
  "/assets/images/couple/C 19.jpg",
  "/assets/images/baby/BABY 14.jpg",
  "/assets/images/bridal/B 27.jpg",
  "/assets/images/couple/C 22.jpg",
  "/assets/images/haldi/H 40.jpg",
  "/assets/images/haldi/H 53.jpg",
  "/assets/images/pre-wedding/PW 05.jpg",
];

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });

    Swal.fire({
      title: "Get In Touch With Us",
      html: `<p style="font-size: 16px; margin-bottom: 15px;">We’d love to hear from you. Click below to contact us.</p>`,
      showCancelButton: true,
      confirmButtonText: "Contact",
      cancelButtonText: "Close",
      showCloseButton: true,
      customClass: {
        popup: 'custom-swal-popup',
        title: 'custom-swal-title',
        actions: 'custom-swal-actions',
        confirmButton: 'custom-swal-confirm',
        cancelButton: 'custom-swal-cancel',
        closeButton: 'custom-swal-close',
      },
      allowOutsideClick: true,
      allowEscapeKey: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "/contact";
      }
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section>
      <section>
        <section
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "white",
            overflow: "hidden",
          }}
        >
          {/* Background Image Carousel */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              overflow: "hidden",
            }}
          >
            <img
              src={images[currentIndex]}
              alt="Hero Background"
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "brightness(0.5)",
                transition: "opacity 1s ease-in-out",
              }}
            />
          </div>

          {/* Overlay Content */}
          <div
            style={{
              position: "relative",
              zIndex: 10,
              textAlign: "center",
              color: "white",
              padding: "0 20px",
            }}
          >
            <h3
              className="hero-heading-subtitle"
              style={{
                fontSize: "1.5rem",
                textTransform: "uppercase",
                letterSpacing: "3px",
                marginBottom: "50px",
                fontWeight: "500",
              }}
            >
              Romesh Bhakte Films
            </h3>
            <h1
              className="hero-heading-title"
              style={{
                fontSize: "3.5rem",
                fontWeight: "bold",
                marginBottom: "20px",
                lineHeight: "normal",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
              }}
            >
              The Companion of Your Happiness
            </h1>
            <div
              style={{
                width: "60px",
                height: "2px",
                backgroundColor: "white",
                margin: "10px auto",
              }}
            ></div>
          </div>
        </section>

        {/* Responsive + SweetAlert2 Custom Styles */}
        <style>
          {`
            @media (max-width: 768px) {
              .hero-heading-title {
                font-size: 2.5rem;
                line-height: 1.3;
              }
              .hero-heading-subtitle {
                font-size: 1.2rem;
              }
            }

            @media (max-width: 480px) {
              .hero-heading-title {
                font-size: 2rem;
                line-height: 1.3;
                word-wrap: break-word;
              }
              .hero-heading-subtitle {
                font-size: 1rem;
                margin-bottom: 20px;
                display: none;
              }
            }

            .swal2-popup.custom-swal-popup {
              font-family: 'Arial', sans-serif;
              padding: 25px;
              border-radius: 12px;
              width: 90%;
              max-width: 400px;
            }

            .swal2-title.custom-swal-title {
              font-size: 22px;
              font-weight: 600;
              margin-bottom: 10px;
            }

            .swal2-actions.custom-swal-actions {
              display: flex;
              justify-content: center;
              gap: 12px;
              flex-wrap: wrap;
            }

            .swal2-confirm.custom-swal-confirm,
            .swal2-cancel.custom-swal-cancel {
              font-size: 14px;
              border-radius: 5px;
              padding: 10px 25px;
              width: auto;
              min-width: 100px;
            }

            .swal2-confirm.custom-swal-confirm {
              background-color: black !important;
              color: white !important;
              border: none !important;
            }

            .swal2-cancel.custom-swal-cancel {
              background-color: white !important;
              color: black !important;
              border: 1px solid black !important;
            }

            .swal2-close.custom-swal-close {
              font-size: 1.5rem;
              color: #999;
              top: 10px;
              right: 10px;
            }
          `}
        </style>
      </section>
    </section>
  );
};

export default Hero;
